<section
  #advisoryContent
  [id]="content.messageBanner.id"
  class="message-banner"
></section>
